/**
 * 大屏 V3（LargeScreenV3）挂载时在 document.documentElement 上添加 class，
 * ECharts 等业务组件通过 ls3ChartFont() 缩小字号，离开页面时移除。
 */
export const LS3_CHART_COMPACT_CLASS = 'ls3-chart-compact'

export function isLs3ChartCompact() {
  if (typeof document === 'undefined') {
    return false
  }
  return document.documentElement.classList.contains(LS3_CHART_COMPACT_CLASS)
}

/**
 * 根据是否处于大屏 V3 返回缩放后的字号（画布内文字）
 * @param {number} basePx - 正常页面的 px 字号
 * @returns {number}
 */
export function ls3ChartFont(basePx) {
  if (!isLs3ChartCompact()) {
    return basePx
  }
  return Math.max(9, Math.round(basePx * 0.68))
}
